import { DataTable } from "../components/data-table";
import { ContextDataTableProvider } from "../context/index";
import {
  DataTableType,
  DefaultFilterValueType,
  DefaultRecordType,
} from "../types/index";

export default function LayoutDataTable<
  RecordType = DefaultRecordType,
  FilterValueType = DefaultFilterValueType,
>(props: DataTableType<RecordType, FilterValueType>) {
  return (
    <>
      <ContextDataTableProvider<RecordType, FilterValueType> {...props}>
        <DataTable />
      </ContextDataTableProvider>
    </>
  );
}
